import React, {useState} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import {Radio} from "antd";
import Brand from "./brand";
import Market from "./market";

function BrandMarket() {

    const [selected, setSelected] = useState('brand')

    return (
        <PageHeaderLayout title={(
            <Radio.Group buttonStyle="solid" value={selected} onChange={e => setSelected(e.target.value)}>
                <Radio.Button value={'brand'}>Brand</Radio.Button>
                <Radio.Button value={'market'}>Market</Radio.Button>
            </Radio.Group>
        )}>
            {selected === 'brand' && (
                <Brand/>
            )}
            {selected === 'market' && (
                <Market/>
            )}
        </PageHeaderLayout>
    )
}


export default BrandMarket
